// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"de0a6b2a","106":"ac0f8bf9","153":"5c38e303","215":"69403838","282":"7a91ba31","380":"0e06451c","435":"cf071127","930":"91eb7c58","984":"239730d9","986":"5560890a"}[chunkId] + ".chunk.js";
};